import { scErrorLogger } from '../services/sentryService';
import {
  disableBackButton,
  isBackDisabled,
  waitForBackEnable,
} from './backButton';
import { GatewayError } from './customErrorTypes';
import uuid4 from './uuid';

export function guardedCall<T extends any[], U>(
  fn: (...args: T) => Promise<U>,
  handleBackButton: boolean = false,
) {
  return async function inner(...args: T): Promise<U> {
    try {
      if (handleBackButton) {
        const functionIdentifier = uuid4();
        disableBackButton(functionIdentifier);
        try {
          // Get the response but wait for back button to be enabled
          const response = await fn.apply(this, args);
          if (isBackDisabled()) {
            await waitForBackEnable(functionIdentifier);
          }
          return response;
        } catch (err) {
          await waitForBackEnable(functionIdentifier);
          throw err;
        }
      }
      return fn.apply(this, args);
    } catch (e) {
      if (!(e instanceof GatewayError)) {
        scErrorLogger.log(e);
      }
      throw e;
    }
  };
}
